import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { UserRegistrationRequestClient } from 'src/shared/api';
import { shareReplay } from 'rxjs/operators';
import { usersFragments } from '../../users.routes';

@Component({
	selector: 'rpfsa-user-header',
	templateUrl: './user-header.component.html',
	styleUrls: ['./user-header.component.scss'],
})
export class UserHeaderComponent implements OnInit {
	@Input() headerText: string;
	@Input() isDisabled: boolean;

	// TODO make this drop as you deny requests
	requestCount$: Observable<number>;

	usersFragments = usersFragments;
	constructor(
		private readonly userRegistrationRequestClient: UserRegistrationRequestClient
	) {}

	ngOnInit() {
		this.requestCount$ = this.userRegistrationRequestClient
			.userRegistrationRequestCount()
			.pipe(shareReplay(1));
	}
}
